export default __webpack_public_path__ + "static/media/withbaby.a38836b466848ec398b131955fe03072.svg";